export const button = {
  save: 'Save',
  add: 'Add',
  yes: 'Yes',
  no: 'No',
  update: 'Update',
  change: 'Change',
  cancel: 'Cancel',
  confirm: 'Confirm',
  upload: 'Upload File',
  import: 'Import file',
  back: 'Back',
  close: 'Close',
  request: 'Request',
  next: 'Next',
  download: 'Download',
  ok: 'OK'
};
